module.exports = __webpack_public_path__ + "img/1796.dfe03dcb.jpg";